var ubian = ubian || {};




ubian.notEquelPasswords = function () {
    var dialog = $($('#js-not-equeul-passwords').html());
    $(dialog).modal();
}
//ubian.emailRegex = /^[a-zA-Z0-9.! #$%&'*+/=? ^_`{|}~-]+@[a-zA-Z0-9-]+(?:\. [a-zA-Z0-9-]+)*$/;
//ubian.emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
//ubian.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
ubian.emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
ubian.nameRegex =/^[^<>@,;*!?]+$/;
$(function () {
    $("#register-form").submit(function(e) {
        //e.preventDefault();
        var name = $("#register-name").val();
        var surname = $("#register-surname").val();
        var passwd = $("#register-password").val();
        var email = $("#register-email").val();
        var passwordCheck = $("#register-password-check").val();
        var termsOfService = $("#termsofservice").prop("checked");

        if (passwd !== passwordCheck) {
            ubian.utils.alert(ubian.translate('User.Error.PasswordMismatch'));
            return false;
        }
        if (passwd.length > 0) {
            if (passwd.length > 0 && passwd.length < 6) {
                ubian.utils.alert(ubian.translate('User.Error.PasswordShort'));
                return false;
            }
            if (!__ubian_password_regex.test(passwd)) {
                ubian.utils.alert(ubian.translate('User.Error.PasswordFormat'));
                return false;
            }
        }

        if(!ubian.emailRegex.test(email)) {
            ubian.utils.alert(ubian.translate('Notification.Error.EmailInvalid'));
            return false;
        }
        if(!ubian.nameRegex.test(name)) {
            ubian.utils.alert(ubian.translate('Notification.Error.NameInvalid'));
            return false;
        }
        if(!ubian.nameRegex.test(surname)) {
            ubian.utils.alert(ubian.translate('Notification.Error.SurnameInvalid'));
            return false;
        }

        if(!termsOfService) {
            $("#termsError").addClass("active");
            return false;
        }
        return true;
    });
    $("#login-form").submit(function(e) {
        //e.preventDefault();
        var email = $("#login-email").val();
        console.log(ubian.emailRegex.test(email));
        if(!ubian.emailRegex.test(email)) {
            ubian.utils.alert(ubian.translate('Notification.Error.EmailInvalid'));
            return false;
        }
        return true;
    });
})



/**
 * logout
 */
ubian.logout = function () {
    var dialog = $($('#js-logout-dialog').html());
    $(dialog).modal();
}

/**
 * registration
 */
ubian.registration = {};
ubian.registration.confirmDialogCallback = null;
/**
 * display modal dialog to confirm terms of service and proceed with registration
 * @param {type} callback
 * @return {undefined}
 */
ubian.registration.confirmDialog = function (callback) {
    ubian.registration.confirmDialogCallback = callback;
    var dialog = $($('#js-register-template').html());
    $(dialog).modal();
    $(dialog).find('.js-register-complete').click(function () {
        if ($(this).parents('.modal-dialog').find('.js-terms-of-service-agreement').is(':checked')) {
            ubian.registration.confirmDialogCallback();
            $(dialog).modal('hide');
        }
    });
    $(dialog).find('.js-terms-of-service-agreement').change(function () {
        var btn = $(this).parents('.modal-dialog').find('.js-register-complete');
        $(btn).toggleClass('btn-transparent-gray');
        $(btn).toggleClass('btn-success');
    });
}
/**
 * display modal when account is not found
 * @return {undefined}
 */
ubian.accountNotFound = function () {
    var dialog = $($('#js-account-not-found').html());
    $(dialog).modal();
}
/**
 * Login progress overlay 
 * @type {type}
 */
ubian.loginProgress = {};
ubian.loginProgress.show = function () {
    ubian.utils.fullscreenProgress('Prihlasujem...');
}
ubian.loginProgress.hide = function () {
    ubian.utils.removeFullscreenProgress();
}
/**
 * password reset
 * @type {ubian.resetPassword}
 */
ubian.resetPassword = ubian.resetPassword || {};

ubian.resetPassword.openDialog = function () {
    var dialog = $($('#js-password-reset-dialog').html());
    ubian.showPassword(dialog);
    $(dialog).modal();
    $(dialog).find('.js-submit-password-reset').click(function () {
        ubian.resetPassword.submit(dialog);
    });
}

ubian.resetPassword.submit = function (dialog) {
    var email = $(dialog).find('#reset_email').val();
    var password = $(dialog).find('#reset_password').val();
    var password_check = $(dialog).find('#reset_password_check').val();
    $(dialog).find('.errors').html('');
    $.post(ubian.routes['password_reset'], {
        'email': email,
        'password': password,
        'password_check': password_check
    }, function (res) {
        if (res.status === 'ok') {
            $(dialog).modal('hide');
            ubian.resetPassword.showSuccessDialog(res.email);
        } else {
            $(dialog).find('.errors').html('<div class="modal-error">' + ubian.translate(res.message) + '</div>');
        }
    });

}
ubian.resetPassword.showSuccessDialog = function (email) {
    var html = $('#js-password-reset-success-dialog').html();
    html = html.replace('@email', email);
    $(html).modal();
}
ubian.wrongPassword = function (loginData) {
    var dialog = $($('#js-wrong-password-dialog').html());
    $(dialog).modal();
    $(dialog).find('#reset_email').val(loginData.email);
    $(dialog).find('#reset_password').val(loginData.password);
    $(dialog).find('.js-submit-password-reset').click(function () {
        ubian.resetPassword.submit(dialog);
    });
}


/**
 * account switching
 * @return {undefined}
 */
ubian.switchAccountUbian = function () {
    var dialog = $($('#js-account-exists-ubian').html());
    $(dialog).modal();
}
ubian.switchAccountGoogle = function () {
    var dialog = $($('#js-account-exists-google').html());
    $(dialog).modal();
}
ubian.switchAccountFacebook = function () {
    var dialog = $($('#js-account-exists-facebook').html());
    $(dialog).modal();
}

/**
 * FB Login 
 * @type Object
 */
ubian.fbLogin = ubian.fbLogin || {};

/**
 * try to log in using facebook
 * @return {undefined}
 */
ubian.fbLogin.login = function () {
    FB.login(function (response) {
        ubian.fbLogin.completeLogin(response);
    }, {scope: 'public_profile,email'});
}
/**
 * display registration prompt for facebook
 * @param {Objct} data data from login
 * @return {undefined}
 */
ubian.fbLogin.register = function (data) {
    if (typeof data.email === 'undefined') {
        ubian.fbLogin.requestEmail(data);
        return;
    }
    ubian.registration.confirmDialog(function () {
        $.post(ubian.routes['oauth_register'], data, function (res) {
            if (res.status === 'ok') {
                window.location = res.redir;
            } else {
                ubian.utils.alert(ubian.translate(res.error));
            }
        });
    });

}

ubian.fbLogin.requestEmail = function (data) {
    var dialog = '<div class="modal modal-base modal-alert" role="dialog" id="js-ubian-alert">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-body">' +
            '<button type="button" class="close" data-dismiss="modal">&times;</button>' +
            ubian.translate('JS.Login.FB.RequestEmail') +
            '<br /><br /><input type="text" class="form-control" /><br /><br /><div class="buttons">' +
            '<a href="#" class="btn btn-green">OK</a>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';
    dialog = $(dialog);
    $(dialog).modal();
    $(dialog).find('a').click(function () {
        data.email = $(dialog).find('input').val();
        $(dialog).modal('hide');
        ubian.fbLogin.register(data);
    });

}

/**
 * finish login on site after successful fb login
 * @param {Object} response
 * @return {undefined}
 */
ubian.fbLogin.completeLogin = function (response) {
    var token = response.authResponse.accessToken;
    FB.api('/me?fields=email,first_name,last_name', function (response) {
        if (typeof response.email === 'undefined' || typeof response.first_name === 'undefined' || typeof response.last_name === 'undefined') {
            ubian.utils.confirm(ubian.translate('JS.Login.FB.RequiredInfoMissing'), '', ubian.translate('Button.Register'), ubian.routes['register']);
            return;
        }
        var data = {
            'type': 'fb',
            'token': token,
            'first_name': response.first_name,
            'last_name': response.last_name,
            'email': response.email,
            'id': response.id
        };
        ubian.loginProgress.show();
        $.post(ubian.routes['oauth_login'], data, function (res) {
            ubian.loginProgress.hide();
            if (res.status === 'error') {
                if (typeof res.action !== 'undefined') {
                    ubian.fbLogin[res.action](data);
                } else {
                    ubian.utils.alert(ubian.translate(res.error));
                }
            } else {
                window.location = res.redir;
            }
        });

    });
}
/**
 * Google Login
 * @type {ubian.googleLogin}
 */
ubian.googleLogin = ubian.googleLogin || {};

ubian.googleLogin.login = function () {
    if (typeof ubian.googleLogin.access_token === 'undefined' || !ubian.googleLogin.access_token) {
        return;
    }
    var data = {
        'type': 'google',
        'token': ubian.googleLogin.access_token,
    };
    ubian.loginProgress.show();
    $.post(ubian.routes['oauth_login'], data, function (res) {
        ubian.loginProgress.hide();
        if (res.status === 'error') {
            if (typeof res.action !== 'undefined') {
                ubian.googleLogin[res.action](data);
            } else {
                ubian.utils.alert(ubian.translate(res.error));
            }
        } else {
            window.location = '/redirect_after_login';
        }
    });
}

ubian.googleLogin.register = function (data) {
    ubian.registration.confirmDialog(function () {
        $.post(ubian.routes['oauth_register'], data, function (res) {
            if (res.status === 'ok') {
                window.location = '/redirect_after_login';
            } else {
                ubian.utils.alert(ubian.translate(res.error));
            }
        });
    });
}

/**
 * generic stuff
 */

ubian.googleLogin.switchAccountUbian = ubian.fbLogin.switchAccountUbian = ubian.switchAccountUbian;
ubian.googleLogin.switchAccountFacebook = ubian.fbLogin.switchAccountFacebook = ubian.switchAccountFacebook;
ubian.googleLogin.switchAccountGoogle = ubian.fbLogin.switchAccountGoogle = ubian.switchAccountGoogle;

ubian.loginUpsell = function () {
    var $link = $('.js-login-companies');
    if ($link.length == 0) {
        return;
    }
    $link.data('toggle', 'popover');
    $link.data('placement', 'bottom');
    $link.data('html', true);
    $link.data('content', ubian.translate('Login.ProductPrompt.CompaniesList') + "<br>" + ubian_login_product_companies.join("<br>"));
    $link.popover();
};
/*function ShowAllLoginMessages() {
    $("#messages").children().each(function() {
        var message =  $(this).data("msg-code");
        ubian.utils.alert(ubian.translate(message));
    });
}*/
function CheckUrlResult() {
    var resultVal = GetUrlParam("Result");
    if(resultVal.length === 0) {
        return;
    }

    var notification = ubian.translate("Email.Notification." + resultVal);
    if(notification === "Email.Notification." + resultVal) {
        notification = ubian.translate("Email.Notification.Error");
    }
    ubian.utils.alert(notification);
}

function GetUrlParam(param_p) {
    var url = window.location.search.substring(1);
    var urlParams = url.split("&");

    for(var i = 0; i < urlParams.length ; i++) {
        var param = urlParams[i].split("=");
        if(param[0].toLowerCase() == param_p.toLowerCase()) {
            return param[1];
        }
    }
    return "";
}

// hook event handlers
$(function () {
    $(document).on('click', '.js-login-fb', function () {
        ubian.fbLogin.login();
    });
    ubian.googleLogin.login();
    $('.js-reset-password').click(function () {
        ubian.resetPassword.openDialog();
    });
    ubian.loginUpsell();
    $('.js-DPBAgreement').click(function () {
        if($(this).is(":checked"))
            $(".js-clientPhone").attr("required", "required");
        else
            $(".js-clientPhone").removeAttr("required");
    });
    $('.js-DPBAgreement').change(function () {
        $(this).attr("value", $(this).is(":checked"));
    });
    ubian.loginUpsell();
    $('#termsofservice').change(function () {
        $('.js-register-button').toggleClass('btn-green');
        $('.js-register-button').toggleClass('btn-transparent-gray');
        $("#termsError").removeClass("active");
    });
    $('.js-logout').click(function () {
        ubian.logout();
    });
    // Show all login messages
    //ShowAllLoginMessages();
    // Check result from email link notificaiton
    CheckUrlResult();
});